import { rateConfirmStepMessage } from '@/lib/siteElectricityInput';

/**
 * The second step before a flat rate above 40 cents per kWh saves (Warren, 21 October 2026, night: "raise the utility and
 * reimbursement caps to 60 cents, with a second confirmation above 40"): "43.63 cents per kWh is above 40 cents. Confirm
 * this rate." Confirm saves with confirm_above_40; Change it goes back to the field. The Api asks the same question when
 * the flag is missing, so a stale page cannot skip it. Each screen passes its own button classes.
 */
export function RateConfirmStep({ cents, busy, onConfirm, onCancel, buttonClassName, cancelClassName }: {
  cents: number; busy?: boolean; onConfirm: () => void; onCancel: () => void; buttonClassName?: string; cancelClassName?: string;
}) {
  return (
    <div style={{ border: '1px solid var(--color-warn)', borderRadius: 8, padding: '10px 12px', margin: '8px 0', display: 'grid', gap: 8 }}>
      <p role="alert" style={{ margin: 0, color: 'var(--color-tx)' }}>{rateConfirmStepMessage(cents)}</p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button type="button" className={buttonClassName} disabled={busy} onClick={onConfirm}>Confirm this rate</button>
        <button type="button" className={cancelClassName ?? buttonClassName} disabled={busy} onClick={onCancel}>Change it</button>
      </div>
    </div>
  );
}
